import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsAr from '@angular/common/locales/es-AR';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

/** Pipes `currency` / `date` / `number` con locale explícito `'es'` o `'es-AR'` (NG0701 si falta). */
registerLocaleData(localeEs);
registerLocaleData(localeEsAr);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
